export default __webpack_public_path__ + "static/media/who_we_are.ba78584e.png";